import { combineReducers, configureStore } from "@reduxjs/toolkit";

import policyDetailsSlice, { PolicyDetailsState } from "./slices/policyDetails";
import lossDetailsSlice, { LossLocationDetails } from "./slices/lossType";
import claimDetailsSlice, { ClaimDetails } from "./slices/claimDetails";
import claimDocumentsSlice, {
  ClaimDocumentsState,
} from "./slices/claimDocuments";
import claimReporterSlice, {
  ReportingPartyInput,
} from "./slices/claimReporter";

export type RootState = {
  policyDetails: PolicyDetailsState;
  lossDetails: LossLocationDetails;
  claimDetails: ClaimDetails;
  claimDocuments: ClaimDocumentsState;
  claimReporter: ReportingPartyInput;
};

type MiddlewareOptions = {
  immutableCheck?: boolean;
  serializableCheck?: boolean;
  actionCreatorCheck?: boolean;
};

type SetupStoreOptions = {
  preloadedState?: Partial<RootState>;
  middlewareOptions?: MiddlewareOptions;
};

export const rootReducer = combineReducers({
  policyDetails: policyDetailsSlice.reducer,
  lossDetails: lossDetailsSlice.reducer,
  claimDetails: claimDetailsSlice.reducer,
  claimDocuments: claimDocumentsSlice.reducer,
  claimReporter: claimReporterSlice.reducer,
});

export const setupStore = (options?: SetupStoreOptions) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware(options?.middlewareOptions).concat([]),
    preloadedState: options?.preloadedState,
  });

export const store = setupStore();

export type AppDispatch = typeof store.dispatch;
